module.exports = __webpack_public_path__ + "static/media/ER-RUS1_1XzC1308rUUeFMQmw8E-fkQ55HHEqplbw.03d65556.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/ER-RUS1_1XzC1308rUUeFMQmw8E-fkQ55HHEqplbw
// module id = 660
// module chunks = 0